export default __webpack_public_path__ + "static/media/logo_footer.8e66d0cf.svg";